export default function Websites() {
  return (
    <>
      <h1 className="page-title">Websites</h1>
    </>
  );
}
